<template>
    <div>
        test
    </div>
</template>
<script>
    import JuegoService from '@/services/operadora/loteria/JuegoService';
    export default {
        components: {
        },
        data: () => ({
            integratorListLoading: false,
            integratorList: [],
        }),
        mounted: function () {
        },
        methods: {
            fetchIntegratorList: function () {
                this.integratorListLoading = true;
                JuegoService.fetchIntegratorList({})
                   .then(({ integrator_list }) => {
                        this.integratorList = integrator_list;
                        this.integratorListLoading = false;
                    })
                    .finally(() => {
                        this.integratorListLoading = false;
                    });
            }
        },
        watch: {
           
        }
    }
</script>